// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActionBlockSlice_wrapper__UUap9","titleWrapper":"ActionBlockSlice_titleWrapper__qfZ29"};